module.exports = __webpack_public_path__ + "img/icon-context-mute-off-copy.8b8d189.svg";